module.exports = __webpack_public_path__ + "static/media/CoolingTowerImg.8a38517b.png";